import { render } from 'preact';
import { CheckoutWidget } from './components/CheckoutWidget';
import type { AlohaPayConfig } from './types';
import './styles/checkout.css';

export type { AlohaPayConfig, CustomerData } from './types';

interface AlohaPayInstance {
  destroy: () => void;
}

function validateConfig(config: Partial<AlohaPayConfig>): config is AlohaPayConfig {
  const required: (keyof AlohaPayConfig)[] = ['apiKey', 'container', 'amount'];

  for (const key of required) {
    if (config[key] === undefined || config[key] === null) {
      throw new Error(`AlohaPay: Missing required config option "${key}"`);
    }
  }

  if (typeof config.amount !== 'number' || config.amount <= 0) {
    throw new Error('AlohaPay: "amount" must be a positive number');
  }

  return true;
}

function create(config: AlohaPayConfig): AlohaPayInstance {
  // Validate config
  validateConfig(config);

  // Find container element
  const container = document.querySelector(config.container);
  if (!container) {
    throw new Error(`AlohaPay: Container "${config.container}" not found`);
  }

  // Render widget
  render(<CheckoutWidget config={config} />, container);

  // Return instance with destroy method
  return {
    destroy: () => {
      render(null, container);
    }
  };
}

// Expose globally
const AlohaPay = { create };

// For UMD build
if (typeof window !== 'undefined') {
  (window as unknown as { AlohaPay: typeof AlohaPay }).AlohaPay = AlohaPay;
}

export { create };
export default AlohaPay;
